export default {
  namespaced: true,
  messages: {
    delete: {
      title: "Você tem certeza que quer apagar isso?",
      body: "Uma vez excluídos, todos os registros associados serão excluídos",
      deleted_correctly: "Eliminado corretamente",
      title_n: "Tem certeza de que deseja excluir {n} elementos?",
      all:"Tem certeza de que deseja excluir tudo?",
    },
    reset: {
      title: "Tem certeza que deseja redefinir a senha?",
      counter_title: "Reiniciar o Contador",
      counter: "Você tem certeza de que deseja reiniciar o contador?"
    },
    error: {
      server_error: "Erro ao obter as informações",
      task_not_assigned: "Erro ao atribuir tarefa",
      max_files_exceeded: "Você excedeu o número máximo de arquivos permitidos"
    },
    success: {
      task_assigned: "Tarefa atribuída com sucesso",
      task_completed: "Tarefa marcada como concluída",
      alarm_reopened: "Alarme reaberto com sucesso",
    },
    validation: {
      required: "O campo {field} é obrigatório",
      email_placeholder: "Insira um ou mais e-mails",
      missing_fields: {
        title: "Campos obrigatórios ausentes",
        text: "Por favor, preencha os seguintes campos: {fields}"
      }
    },
    info: {
      begin_download: "Iniciando processo para exportar vídeo...",
      in_process_download: "Processo iniciado com sucesso...",
      finish_download: "A gravação foi baixada com sucesso",
      sending: "enviando",
      advanced_search: "busca avançada",
      clear_filters: "limpar filtros",
      select: "selecionar",
    },
    export: {
      title: "Exportar",
      download: "Download",
      Generating_file: "Generando arquivo...",
      download_succesfully: "Download completa...",
      report_of: "Relatório de {model}",
      report: "Relatorio de",
      full_download: "Download completo",
      downloading_file: 'Baixando arquivo...',
    },
    edit_save: {
      successfully_created: "Criado com sucesso",
      updated_successfully: "Editado com sucesso",
      updated_successfully_withoutCameraUrl: "Editado com sucesso sem atualizar a URL da câmera",
    },
    copy: {
      copied_successfully: "Copiado com sucesso",
      could_not_copy: "Não foi possível copiar",
    },
    import: {
      title: "Importar",
      rems: "Importar arquivo REMS",
      select_file: "Selecione ou arraste e solte o arquivo",
      upload: "Subiendo",
      uploading_file: "Carregando arquivo...",
      upload_succesfully: "Carga completa...",
      example_file: "Arquivo de Amostra",
    },
    loading: {
      title: "Carregando",
      document: "Carregando documento..."
    },
    redirect: {
      login: "Iremos redirecioná-lo para o login em 5 segundos"
    },
    greetings: {
      change_password: "oi {name},"
    },
    session_expiration:{
      expiration: "A sessão está prestes a expirar em",
      continue_session: "Continuar sessão"
    },
    session_lifetime: {
      lifetime_exceeded: "Você esteve inativo; sua sessão será encerrada quando atingir o tempo limite.",
      continue_session: "Continuar sessão"
    },
    errors: {
      general: "Ocorreu um erro",
      loading_document: "Erro ao carregar documento",
      showing_document: "Erro ao exibir documento",
      loading_service_orders: "Erro ao carregar ordens de serviço"
    },
    processing: "processamento",
    activate: {
      title: "Tem certeza de ativar ",
      body: "Uma vez ativado, todos os registros associados serão ativados",
      activated_correctly: "Ativado corretamente",
      confirm: "Confirmar",
      activated_correctly_confirm: "Ativado corretamente",
      error: "Erro ao tentar ativar",
      activating: "Ativando",
      armed_correctly: "Armado corretamente",
      armed_correctly_confirm: "O dispositivo foi armado corretamente",
    },
    desactivate: {
      title: "Tem certeza de desativar ",
      body: "Uma vez desativado, todos os registros associados serão desativados",
      desactivated_correctly: "Desativado corretamente",
      confirm: "Confirmar",
      desactivated_correctly_confirm: "Desativado corretamente",
      error: "Erro ao tentar desativar",
      deactivating: "Desativando",
      disarmed_correctly: "Devidamente desmontado",
      disarmed_correctly_confirm: "O dispositivo foi desarmado com sucesso",
    },
    actions: {
      apply_state: "Aplicar estado",
      no_action_selected: "Nenhuma ação selecionada",
      executing: "Executando",
      in: "em",
      executed_successfully: 'Ação "{action}" executada com sucesso',
      error_executing: "Erro ao executar a ação",
    },
    table_refreshed: "Tabela atualizada com sucesso",
    warning: {
      title: "Aviso",
    },
  },
};
